export default "__VITE_ASSET__BdjuZmmo__"